import React from 'react'

function AccessDenied() {
  return (
    <div className="container" style={{ textAlign: 'center', marginTop: '50px' }}>
      <h1>Session Expired</h1>
      <p>Your session has expired. Please log in again to continue.</p>
      {/* <Link to="/login" className="btn-blue">
        Go to Login
      </Link> */}
    </div>
  );
}

export default AccessDenied;